import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { EmployeeValidationContainerComponent } from './employee-validation-container/employee-validation-container.component';
const log = new LoggingService();

export const EmployeeValidationRoute: Ng2StateDeclaration = {
    // name: 'EmployeeValidation.**'
    name: 'employeevalidation',
    url: '/employeevalidation',
    // , loadChildren: () => import('./employee-validation.module').then(r => r.EmployeeValidationModule)
    data: { requiresAuth: true },

    component: EmployeeValidationContainerComponent
};
